import { makeStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';

interface CustomTooltipProps {
  detail: any;
  htmlColor?: string;
  icon?: 'info' | 'warning';
}

export const CustomTooltip = (props: CustomTooltipProps) => {
  const iconComponent = () => {
    switch (props?.icon) {
      case 'info':
        return <InfoIcon fontSize="small" htmlColor={props?.htmlColor} />;
      case 'warning':
        return <WarningIcon fontSize="small" htmlColor={props?.htmlColor} />;
      default:
        return <InfoIcon fontSize="small" htmlColor={props?.htmlColor} />;
    }
  };

  return (
    <Tooltip
      style={{ padding: 0 }}
      arrow
      placement="top"
      title={props.detail}
      interactive
    >
      {iconComponent()}
    </Tooltip>
  );
};

export const useStyles = makeStyles({
  root: {
    '& input:valid + fieldset': {
      borderColor: '#00A29B',
      borderWidth: 2,
    },
  },
  tooltip: {
    fontSize: '1em',
  },
});
